export default {
  namespaced: true,

  getters: {
    officesByRole: (_, __, rootState, rootGetters) => rootGetters['apis/forSelect']('offices')
      .filter(({ value }) => rootState.auth.user.roles.all.includes('offices') ? true : rootState.auth.user.roles.offices.includes(value)),
  },
}
